<template>
  <a-card :bordered="false">
    <h1>库存调拨</h1>
    <a-form
      layout="inline"
      :autoFormCreate="
        (form) => {
          this.searchForm = form;
        }
      "
    >
      <a-form-item
        label="调出门店"
        fieldDecoratorId="out_branch_id"
        :fieldDecoratorOptions="{ initialValue: userInfo.branch_id }"
      >
        <a-select
          placeholder="请选择"
          :style="{ width: '220px' }"
          show-search
          option-filter-prop="children"
          :disabled="cannotfilterStore"
        >
          <a-select-option v-for="item in branches" :key="item.id">{{
            item.name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="sku" fieldDecoratorId="sku">
        <a-input placeholder="sku" :style="{ width: '320px' }" />
      </a-form-item>
      <a-button type="primary" @click="handleAdd">添加</a-button>
    </a-form>
    <div class="tips">
      请输入钉钉审批编号，调拨需钉钉申请并通过运营经理，采购经理，财务经理，调入门店店长同意，并且注明调拨详细理由
    </div>
    <div class="content content-header">
      <div class="content-1">sku</div>
      <div class="content-2">调出门店</div>
      <div class="content-3">商品名称</div>
      <div class="content-4">当前库存</div>
      <div class="content-5">调入门店</div>
      <div class="content-6">调拨数量</div>
      <!-- <div class="content-7">调拨原因</div> -->
    </div>
    <div class="content" v-for="item in rows" :key="item.sku">
      <div class="content-1">{{ item.sku }}</div>
      <div class="content-2">{{ item.branch_name }}</div>
      <div class="content-3">{{ item.goods_name }}</div>
      <div class="content-4">{{ item.unit_stock }}</div>
      <div class="content-5">
        <a-select
          placeholder="请选择"
          :style="{ width: '220px' }"
          show-search
          option-filter-prop="children"
          v-model="item.branch_id"
        >
          <a-select-option v-for="branch in branches" :key="branch.id">{{
            branch.name
          }}</a-select-option>
        </a-select>
      </div>
      <div class="content-6">
        <a-input v-model.number="item.quantity" placeholder="调拨数量" />
      </div>
    </div>
    <!-- <div class="ding_talk"></div> -->
    <div class="btn">
      <a-input
        :style="{ width: '168px' }"
        v-model="ding_talk_order_no"
        placeholder="钉钉审批单号"
      />
      <a-divider type="vertical" />
      <a-button type="primary" @click="handleSave">提交</a-button>
      <a-divider type="vertical" />
      <a-button type="primary" @click="handleGoRecord">调拨记录</a-button>
    </div>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import AInput from "ant-design-vue/es/input/Input";
import { getStockList, moveStock } from "@/api/stock";
import { getBranchList } from "@/api/branch";

export default {
  name: "StockList",
  components: {
    AInput,
    STable,
  },
  data() {
    return {
      ding_talk_order_no: "", //钉钉审批单号
      cannotfilterStore: false,
      form: null,
      // 查询参数
      searchForm: null,
      queryParam: {},
      // 表头
      branches: [],
      rows: [],
      userInfo: {},
    };
  },
  created() {
    this.getBranchList();
    let userInfo = this.$ls.get("userInfo");
    let canotfilterStoreRole = ["manager", "clerk"];
    this.cannotfilterStore = canotfilterStoreRole.includes(userInfo.role);
    this.userInfo = userInfo;
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    handleAdd: function () {
      const params = {
        sku: this.searchForm.getFieldValue("sku"),
        branch_id: this.searchForm.getFieldValue("out_branch_id"),
        page: 1,
        page_size: 10000,
      };
      if (!params.branch_id) {
        this.$message.error("请选择调出门店后添加");
        return;
      }
      if (!params.sku) {
        this.$message.error("请输入sku后添加");
        return;
      }
      if (this.rows.length > 0 && params.branch_id !== this.rows[0].branch_id) {
        this.$message.error("请添加调出门店与已有调出门店相同的sku");
        return;
      }
      getStockList(params).then((res) => {
        const { id, sku, branch_name, goods_name, unit_stock, branch_id } =
          res.list[0] || {};
        let item = {
          id,
          sku,
          branch_name,
          goods_name,
          unit_stock,
          branch_id,
        };
        if (id) {
          this.rows = [...this.rows, item];
        } else {
          this.$message.warn("无对应的结果");
        }
      });
    },

    handleSave: function () {
      if (this.rows.length === 0) {
        this.$message.warn("至少选择一个个门店和库存调拨");
        return;
      }
      const params = this.rows.map((i) => ({
        id: i.id,
        quantity: i.quantity,
        branch_id: i.branch_id,
        ding_talk_order_no: this.ding_talk_order_no,
      }));
      if (
        params.some(
          (i) => !i.quantity || !i.branch_id || !this.ding_talk_order_no
        )
      ) {
        this.$message.warn("调入数量/门店/钉钉审批单号不能为空");
        return;
      }
      moveStock(params).then((res) => {
        this.ding_talk_order_no = "";
        this.rows = [];
        this.$message.success("调拨成功");
      });
    },
    handleGoRecord: function () {
      let routertwo = this.$router.resolve({ name: "allocationRecord" });
      window.open(routertwo.href, "_blank");
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
.content {
  display: flex;
  border-bottom: 1px solid #ddd;
  padding: 10px 5px;
}
.content-header {
  font-weight: bold;
  background: #ddd;
  margin-top: 20px;
}
.content-1 {
  flex: 1;
}
.content-2 {
  width: 260px;
}
.content-3 {
  width: 220px;
}
.content-4 {
  width: 180px;
}
.content-5 {
  width: 260px;
}
.content-6 {
  width: 160px;
  padding: 0 8px;
}
.content-7 {
  width: 220px;
}
.btn {
  margin-top: 20px;
  text-align: center;
}
.tips {
  color: red;
}
.ding_talk {
  margin: 20px 0;
  text-align: center;
}
</style>
